(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["merqosa-subscription-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
    let observer;

    const selectSubscription = () => {
      const input = document.querySelector(
        ".yx-subscription-component input[name='subscription_enabled']"
      );

      if (!input) return false;
      if (!input.checked) input.click();
      return true;
    };

    const initialize = () => {
      if (selectSubscription()) return;

      observer = new MutationObserver(() => {
        if (selectSubscription()) observer.disconnect();
      });

      observer.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 10000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
